import { H1, Link } from 'platform-components';
import { Route, Switch } from 'platform-components/src/components/router/router';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { matchPath } from 'react-router-dom';
import { compose } from 'redux';

import { BetaBanner } from 'common.components/beta-banner/beta-banner';
import PageContentTitle from 'common.components/page-content-title/page-content-title';
import { getClasses } from 'common.components/user/selectors';

// @ts-ignore
import ArchivedClasses from '../__archive-classes/class__archive-classes';
// @ts-ignore
import Classes from '../__classes/class__classes';
// @ts-ignore
import Empty from '../__empty/class__empty';
import ParentNotification from '../__parent-notification/class__parent-notification';
import ClassStudents from '../__students/class__students';
import ClassSubjects from '../__subjects/class__subjects';
import ClassTabs from '../__tabs/class__tabs';
import ClassTeacherList from '../__teacher-list/class__teacher-list';
import { ReduxTeacherStore } from '../../../typings';
import { getIsExamsResultsEnabled } from '../../exams-results/selectors';

import './class__view.scss';

interface HOCProps extends WithRouterPathProps {}

type StoreProps = ReturnType<typeof mapStateToProps>;

interface Props extends HOCProps, StoreProps {}

export class ClassView extends React.Component<Props> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };

    componentDidMount() {
        const { location } = this.props;
        const {
            staticUrls: { labClasses },
        } = this.context;

        const { pathname } = location;

        if (!matchPath(pathname, { path: labClasses })) {
            this.redirectToEmptyClass();
        }
    }

    componentDidUpdate(prevProps: Props) {
        const { teams: prevTeams } = prevProps;
        const { teams } = this.props;

        if (prevTeams !== teams) {
            this.redirectToEmptyClass();
        }
    }
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    redirectToEmptyClass = () => {
        const { teams, getRouterPath, history } = this.props;
        const {
            staticUrls: { labClasses },
        } = this.context;

        if (!teams || teams.length === 0) {
            history.push(getRouterPath(labClasses));
        }
    };

    getExamsResultsLink = () => {
        const { teamId, teams, getRouterPath } = this.props;
        const {
            staticUrls: { labClassExamsResults },
        } = this.context;

        // классы 9-11, тк можно сохранить прошлогодние результаты
        let graduatingTeamId;

        const currentTeam = teams.find((team) => team.id === teamId);
        if (currentTeam && currentTeam.level >= 9) {
            graduatingTeamId = currentTeam.id;
        } else {
            graduatingTeamId = teams.find((team) => team.level >= 9)?.id;
        }

        return graduatingTeamId && getRouterPath(labClassExamsResults, { classId: graduatingTeamId });
    };

    render() {
        const { teamId, examsResultsEnabled } = this.props;
        const {
            staticUrls: { labClassStudents, labClassTeachers, labClassSubjects },
        } = this.context;

        const examsResultsLink = this.getExamsResultsLink();

        return (
            <div className="class__view">
                <BetaBanner className="class__view-beta-banner" section="teams" />
                <div className="class__view-classes-column">
                    <Classes />
                    <ArchivedClasses />
                    <ParentNotification />
                </div>
                <div className="class__view-students-column">
                    <PageContentTitle title={<H1 id="class.settings.header" />} />

                    {examsResultsEnabled && examsResultsLink && (
                        <Link isRouter mix="class__exams-results-link" theme={Link.THEME.PRIMARY} to={examsResultsLink}>
                            Заполнить результаты ОГЭ по информатике
                        </Link>
                    )}

                    {teamId ? (
                        <React.Fragment>
                            <ClassTabs />
                            <Switch>
                                <Route component={ClassStudents} path={labClassStudents} />
                                <Route component={ClassTeacherList} path={labClassTeachers} />
                                <Route component={ClassSubjects} path={labClassSubjects} />
                            </Switch>
                        </React.Fragment>
                    ) : (
                        <Empty />
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps) => {
    const {
        match: {
            params: { classId },
        },
    } = ownProps;

    return {
        teams: getClasses(storeState),
        teamId: Number(classId),
        examsResultsEnabled: getIsExamsResultsEnabled(storeState),
    } as const;
};

export default compose(withRouterPath, connect(mapStateToProps))(ClassView);
